import { useCallback, useEffect, useState } from 'react'
import { Users, Clock, CheckCircle2, XCircle } from 'lucide-react'
import { PageHeader } from '@/components/ui/PageHeader'
import { CredentialingProvidersService } from '@/services/modules/CredentialingService'
import { toast } from '@/components/ui/Toast'
import { currentMonthRange, ReportFilters } from './reportShared'

interface Summary { total: number; inProgress: number; accepted: number; rejected: number }

export function CredentialingReportDashboardPage() {
  const init = currentMonthRange()
  const [from, setFrom] = useState(init.from)
  const [to, setTo] = useState(init.to)
  const [data, setData] = useState<Summary | null>(null)
  const [loading, setLoading] = useState(false)

  const load = useCallback(async (f: string, t: string) => {
    if (!f || !t) return
    setLoading(true)
    try { setData(await CredentialingProvidersService.reportDashboard(f, t)) }
    catch { toast.error('Erro ao carregar o dashboard.') }
    finally { setLoading(false) }
  }, [])

  useEffect(() => { load(init.from, init.to) }, [load, init.from, init.to])

  const cards = [
    { label: 'Total de cadastros', value: data?.total ?? 0,      icon: Users,        color: 'text-gray-700',     ring: 'ring-gray-200',     bg: 'bg-gray-50' },
    { label: 'Em andamento',       value: data?.inProgress ?? 0, icon: Clock,        color: 'text-amber-600',    ring: 'ring-amber-200',    bg: 'bg-amber-50' },
    { label: 'Aceitos',            value: data?.accepted ?? 0,   icon: CheckCircle2, color: 'text-emerald-600',  ring: 'ring-emerald-200',  bg: 'bg-emerald-50' },
    { label: 'Rejeitados',         value: data?.rejected ?? 0,   icon: XCircle,      color: 'text-rose-600',     ring: 'ring-rose-200',     bg: 'bg-rose-50' },
  ]

  return (
    <>
      <PageHeader title="Dashboard de credenciamento" subtitle="Visão geral dos cadastros no período"
        crumbs={[{ label: 'Credenciamento' }, { label: 'Relatórios' }, { label: 'Dashboard' }]}
      />
      <ReportFilters from={from} to={to} onFrom={setFrom} onTo={setTo} onApply={() => load(from, to)} loading={loading} />

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map(c => (
          <div key={c.label} className={`rounded-md ring-1 ${c.ring} ${c.bg} p-5`}>
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium text-gray-500">{c.label}</span>
              <c.icon size={18} className={c.color} />
            </div>
            <div className={`mt-3 text-3xl font-bold ${c.color}`}>{c.value}</div>
          </div>
        ))}
      </div>
    </>
  )
}
